import { render, staticRenderFns } from "./daily.vue?vue&type=template&id=4704d85a&"
import script from "./daily.vue?vue&type=script&lang=js&"
export * from "./daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports